import colors from './variables/colors';
import metrics from './variables/metrics';

const theme = {
  colors,
  metrics,
};

export default theme;
